import React from "react";
import { Form, FormGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";

import Input from "../../../../components/common/input/Input";
import Button from "../../../../components/common/button/Button";
import Error from "../../../../components/common/error/Error";
import { required, email } from "../../../../utils/forms/validators";
import styles from "./LogIn.scss";

import { LOGIN_FORM } from "../../../../actions/auth.actions";

const emailValidation = email("Please enter a valid email address.");
class LogIn extends React.Component {
  render() {
    return (
      <section>
        <section className={styles.memberLogIn}>
          <div className={styles.content}>
            <h2 className={styles.title}>Log In to Your Account</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <div className={styles.subtitle}>
                  <span>
                    Don't have an account yet?&nbsp;
                    <a
                      target="_blank"
                      href="https://www.thesecondshift.com/create-an-account/"
                    >
                      Sign up here
                    </a>
                    &nbsp;to get started.
                  </span>
                </div>

                <FormGroup>
                  <Field
                    name="email"
                    type="text"
                    placeholder="Email Address"
                    component={Input}
                    validate={[required, emailValidation]}
                  />

                  <Field
                    name="password"
                    type="password"
                    placeholder="Account Password"
                    component={Input}
                    validate={[required]}
                    autoComplete="off"
                  />
                </FormGroup>

                <Button type="submit" size="large" label="Log in" />

                <Error />

                <div className={styles.subtitle}>
                  <span>
                    Forgot your password? No problem.&nbsp;
                    <Link
                      to={{
                        pathname: "/forgot-password",
                        query: {
                          emailValue: _.get(
                            document.getElementById("email"),
                            "value"
                          )
                        }
                      }}
                    >
                      Reset it here.
                    </Link>
                  </span>
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

export default reduxForm({
  form: LOGIN_FORM
})(LogIn);



// WEBPACK FOOTER //
// ./src/routes/common/logIn/components/LogIn.js